import axios from 'axios';
import { API_URL } from '@/env';

let isRedirectingToLogin = false;

const clearAuthSession = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('currentWebsiteId');
};

const redirectToLogin = () => {
  if (typeof window === 'undefined') return;
  if (window.location.pathname === '/login') return;
  if (isRedirectingToLogin) return;

  isRedirectingToLogin = true;
  const currentPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  window.location.assign(`/login?redirect=${encodeURIComponent(currentPath)}`);
};

const axiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json'
  }
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      // ✅ NO redirigir si es un error específico de negocio (ej: suscripción expirada del propietario)
      const isBusinessError = error.response.data?.code === 'WEBSITE_OWNER_SUBSCRIPTION_EXPIRED';
      
      if ((error.response.status === 401 || error.response.status === 403) && !isBusinessError) {
        clearAuthSession();
        redirectToLogin();
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
